import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from "@mui/system";
import Stack from '@mui/material/Stack';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { locationCategories, yesNo } from "../../Components/common/Constants";
import { Button, Row, Col, Input, Select, message, Checkbox, Flex } from "antd";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import { PicCenterOutlined, ProductOutlined } from "@ant-design/icons";
import FormGrid from "../../Components/common/FormGrid";
import { decodeId } from "../../Components/common/CommonFun";

const Auth = new AuthService();

export default function ProductLocation(props) {

  const navigate = useNavigate();
  const params = useParams();
    const decodedID = decodeId(params?.id)

  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const dispatch = useDispatch()
  const { locations, products, aisles, roles, type: roleType } = useSelector((state) => state?.AppState?.userCreds);
  const canAccess =
    roleType === 0 ||
    roleType === 1 ||
    (roleType === 2 && roles?.some((role) => role.role_id === 4));


  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [locationDetails, setLocationDetails] = React.useState({

    aisle: null,
    product: null,
    location: null,
    location_type: null,
    is_transit: false,
    is_picking: false,
    is_binning: false,
  });

  const [avaiableLocations, setAvailableLocations] = React.useState([])


  React.useEffect(() => {
    const fetchProductLocation = async () => {
      if (id > 0) {
        showLoading(layoutDispatch);
        try {
          const res = await Auth.fetch(`/product-location/product-location?id=${id}`);
          if (res.ack) {
            const locs = locations
            ?.filter(loc => loc?.is_picking === 1) 
            .filter(loc => loc?.aisle_id === res?.product_location?.aisle_id);
            setAvailableLocations(locs ?? [])
            setLocationDetails((prev) => ({
              ...prev,
              aisle: res?.product_location?.aisle_id,
              location: res?.product_location?.location_id,
              product: res?.product_location?.product_netsuite_id,
              location_type: res?.product_location?.type,
              is_transit: res?.product_location?.is_transit == 1 ? true : false,
              is_picking: res?.product_location?.is_picking == 1 ? true : false,
              is_binning: res?.product_location?.is_binning == 1 ? true : false,
            }));
          } else {
            showMessage("error", 'Failed to fetch product location');
          }
        } catch (err) {
          showMessage("error", 'Failed to fetch product location');
        } finally {
          hideLoading(layoutDispatch);
        }
      }
    };

    fetchProductLocation();
  }, []);


  const onClickCancel = () => {
    navigate("/product-locations");
  };

  const getAllPro = async () => {
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/product/products`);
      if (res.ack) {
        if (res?.products.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_PRODUCTS',
            payload: { products: res?.products, timestamp: newTimestamp },
          });
        }

        // setProducts(res?.products)
      } else {
        showMessage('error', res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage('error', "Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleSubmit = async () => {

    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    const validations = [
      { key: 'aisle', message: 'Please add aisle' },
      { key: 'location', message: 'Please add location' },
      { key: 'product', message: 'Please add product' },
      // { key: 'location_type', message: 'Please add location type' },
    ];

    for (const { key, message: errorMessage } of validations) {
      if (isEmptyOrUndefined(locationDetails?.[key])) {
        showMessage('error', errorMessage);
        return;
      }
    }
    showLoading(layoutDispatch);
    const isUpdate = id > 0;
    const dataToSend = {
      id: isUpdate ? id : undefined,
      // type: locationDetails.location_type,
      // is_transit: locationDetails.is_transit ? 1 : 0,
      aisle_id: locationDetails.aisle,
      location_id: locationDetails.location,
      product_netsuite_id: locationDetails.product,
      is_picking:  1,
      is_binning: 0,
    }
    try {
      const method = isUpdate ? "PUT" : "POST";
      const res = await Auth.fetch("/product-location/product-location", {
        method: method,
        body: JSON.stringify(dataToSend),
      })
      if (res?.ack) {
        getAllPro();
        showMessage('success', res?.message)
        navigate('/product-locations')
      } else {
        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const filteredLocations = React.useMemo(() => {
  if (!locationDetails.aisle) return [];

  return locations
    ?.filter(loc => loc?.is_picking === 1) 
    .filter(loc => loc?.aisle_id === locationDetails.aisle); 
}, [locations, locationDetails.aisle]);


  console.log(filteredLocations);

  const formItems =[
    {
      label: "Aisle",
      value: locationDetails?.aisle,
      options: aisles,
      onChange: (val) => {
        setLocationDetails({ ...locationDetails, aisle: val, location: null })
        const locs = locations
        ?.filter(loc => loc?.is_picking === 1) 
        .filter(loc => loc?.aisle_id === val);
        setAvailableLocations(locs ?? [])
      },
      icon: <PicCenterOutlined style={{ color: "#13c2c2"}}/>,
      readOnly: false,
      type: 'select',
      data: 'constants'
    },
    {
        label: "Location",
        value: locationDetails?.location,
        options: avaiableLocations,
        onChange: (val) => setLocationDetails({ ...locationDetails, location: val }),
        icon: <ProductOutlined style={{ color: "#722ed1"}}/>,
        readOnly: false,
        type: 'select',
        data: 'locations',
      },
      {
        label: "Product",
        value: locationDetails?.product,
        options: products,
        onChange: (val) => setLocationDetails({ ...locationDetails, product: val }),
        icon: <ProductOutlined style={{ color: "#1677ff"}}/>,
        readOnly: false,
        type: 'select',
        data: 'products',
      },
    ]

  return (
    <>
      <h1 style={{ margin: 0}}> {id > 0 ? "Update" : "Add"} Picking Location</h1>

      <FormGrid formItems={formItems} viewType='page' />
      {/* <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Aisle<span style={{ color: "red" }}>*</span>
          </span>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            value={locationDetails.aisle}
            placeholder="Aisle"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => setLocationDetails({ ...locationDetails, aisle: value, location: null })}
          >
            {aisles?.map((item) => (
              <Option key={item?.id} value={item?.id}>
                {item?.title}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Location<span style={{ color: "red" }}>*</span>
          </span>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            value={locationDetails.location}
            placeholder="Location"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => setLocationDetails({ ...locationDetails, location: value })}
          >
            {filteredLocations?.map((item) => (
              <Option key={item?.id} value={item?.id}>
                {` ${item?.code} - ${item?.title} `}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Product<span style={{ color: "red" }}>*</span>
          </span>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            value={locationDetails.product}
            placeholder="Product"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => setLocationDetails({ ...locationDetails, product: value })}
          >
            {products?.map((item) => (
              <Option key={item?.netsuite_id} value={item?.netsuite_id}>
                {` ${item?.code} - ${item?.name} `}
              </Option>
            ))}
          </Select>
        </Col>
      </Row> */}
      <Flex justify="end" gap={5} style={{ marginTop: "40px" }}>
        <Button
          onClick={onClickCancel}
        >
          Cancel
        </Button>
        {canAccess && (
          <Button type="primary" onClick={handleSubmit}>
            Save
          </Button>
        )}
      </Flex>
    </>
  );
}
